import {
    GET_TERMINAL_DEF,
    GET_TERMINAL_DEF_SUCCESS,
    TERMINAL_DEF_API_ERROR
} from "./actionTypes"

export const getTerminalDefList = () => ({
    type: GET_TERMINAL_DEF,
})

export const getTerminalDefListSuccess = record => ({
    type: GET_TERMINAL_DEF_SUCCESS,
    payload: record,
})

export const terminalDefApiError = error => {
    return {
        type: TERMINAL_DEF_API_ERROR,
        payload: error,
    }
}
